import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Doc } from 'src/@types/docs';
import { DocsRequests } from 'src/requests/docs';
import { QueryKey } from 'src/utils/react-query';

export const useRestoreDocMutation = () => {
  const queryClient = useQueryClient();

  const { mutateAsync: restoreDoc, isLoading: isRestoringDoc } = useMutation(
    (id: string) => DocsRequests.retoreDocFromTrash(id),
    {
      onSuccess(restoredDoc) {
        queryClient.setQueriesData<Doc[]>([QueryKey.DOCS], (contents) => [
          ...(contents || []),
          restoredDoc,
        ]);
        queryClient.setQueryData<Doc[]>(['docsTrash'], (contents) =>
          contents?.filter((content) => content._id !== restoredDoc._id),
        );

        return restoredDoc;
      },
    },
  );

  return {
    restoreDoc,
    isRestoringDoc,
  };
};
